import QuickDeposit from "./quickdeposit";
import logger from "../../apps/root/assets/js/logger";

export let BehaviorsIntpages = (function() {

  const init = function() {

    logger.log("INTERNAL PAGE READY");

    //-------------------[HIDE PRELOADER ON HOMEPAGE]┐
    if ( $('#PreloaderBox') ) {
      TweenMax.to("#PreloaderBox",1, {autoAlpha:0, ease:Power0.easeNone});
    }
    //-------------------[HIDE PRELOADER ON HOMEPAGE]┘

    //-------------------[IF DESKTOP AUTO SHOW MENU LEFT]┐
    if ($(window).width() >= 800){
            setTimeout(function(){
                $("#BtnHamMenu").toggleClass("Cross");
                $("#ConMenuLeft").toggleClass("Opened");
                AniMenuLeft();
                // AddRemoveBlur();
            }, 10);
    }
    //-------------------[IF DESKTOP AUTO SHOW MENU LEFT]┘

    // ------------------------------------------ [HAMBURGUER BTN]┐
    var DelayMenu = 0.1;
    $("#BtnHamMenu").click(function() {
        $(this).toggleClass("Cross");
        if ( $( this ).hasClass( "Cross" ) ) {
            AniMenuLeft();
        }
        $("#ConMenuLeft").toggleClass("Opened");
        AddRemoveBlur();
    });
    function AniMenuLeft(){
        TweenLite.set(["#LogoMenu"], {y:-100, opacity:0});
        TweenMax.to("#LogoMenu",1, {y:0, opacity:1, delay:DelayMenu, ease:Elastic.easeOut});
        //TweenLite.set(["#RowBtnsUser"], {y:-100, opacity:0});
        TweenMax.to("#RowBtnsUser",1, {y:0, opacity:1, delay:DelayMenu + 0.1, ease:Elastic.easeOut});
        //TweenLite.set(["#MenuNav"], {y:-100, opacity:0});
        TweenMax.to("#MenuNav",1, {y:0, opacity:1, delay:DelayMenu + 0.2, ease:Elastic.easeOut});
        TweenLite.set(["#RowSocials"], {y:-100, opacity:0});
        TweenMax.to("#RowSocials",1, {y:0, opacity:1, delay:DelayMenu + 0.3, ease:Elastic.easeOut});
    }
    // ------------------------------------------ [HAMBURGUER BTN]┘




    //[OVER OUT BTS]-------------------------------------------[OVER OUT BTS]-------------------------------------[OVER OUT BTS]┐
    $(".AllBtns").mouseover(function (event){ TweenMax.to(this, 0.3, {scale:1.2, delay:"0", ease:Quad.easeOut}); });
    $(".AllBtns").mouseout(function (event){  TweenMax.to(this, 0.3, {scale:1, delay:"0", ease:Quad.easeOut}); });
    $("#PromoTopBox").mouseover(function (event){ TweenMax.to("#BtnCtaPN", 0.3, {scale:1.1, delay:"0", ease:Quad.easeOut});   });
    $("#PromoTopBox").mouseout(function (event){  TweenMax.to("#BtnCtaPN", 0.3, {scale:1, delay:"0", ease:Quad.easeOut});     });
    //[OVER OUT BTS]-------------------------------------------[OVER OUT BTS]-------------------------------------[OVER OUT BTS]┘

    function AddRemoveBlur() {
          $("#Wrapper").toggleClass("Blur");
          $(".RowsConts").toggleClass("Blur");
    }




    //--------------------------------[ BTN GO TOP ]┐
    $("html, body").animate({ scrollTop: 0 }, "200");
    $("#BtnGoTop").click(function(){
      $("html, body").animate({scrollTop:0},"500");
    });
    $(window).scroll(function(){
      if($(this).scrollTop()>0){
          $("#BtnGoTop").slideDown(300);
      }else{$("#BtnGoTop").slideUp(300);}
    });
    //--------------------------------[ BTN GO TOP ]┘



    //[CONTROL CAROUSEL WINNERS HOME]---------------------------------------------------[CONTROL CAROUSEL WINNERS HOME]┐
    //-----------------------------------------------------------------------------------------------------------------------------[LOAD JSON CAROUSEL WINNERS HOME]┐
    /*var min=0; var max=10; var random = Math.random() * (+max - +min) + +min;
    var UrlJsonLastWinners = "data/data_last_winners.json?ver="+random+""; logger.log(UrlJsonLastWinners);
    var DataLastWinners = $.ajax({cache: false, url:UrlJsonLastWinners, dataType: "json", })
    .fail(function(DataLW) {
        logger.log("DATA  LAST WINNERS [ERROR!]");
    })
    .done(function(DataLW) {
        logger.log("DATA LAST WINNERS [SUCCESS!]");
        var CounterLWinners = $( DataLW ).length;
        // //logger.log(DataLW);
        // var FolferImgs = "new-home/images/games-last-winners/";
        InsertHtmlLastWinners();

        function InsertHtmlLastWinners(){
            for (var i = 0, len = DataLW.length; i < len; i++) {
                var NameWinner = DataLW[i].Winner.Name;
                var PrizeWinner = DataLW[i].Winner.Prize;
                var UrlGameW = DataLW[i].Winner.UrlGame;
                var GameNames = DataLW[i].Winner.GameName;
                var UrlGoPage = "https://bonusblitz.com/games";
                $("#WinnersCarousel").append(
                  "<div class='item'><div class='BoxWinner'><span class='NameWinner'>"+NameWinner+"</span> just won <br /><span class='MounWin'>$"+PrizeWinner+"</span> Playing <span class='GameWin'>"+GameNames+"</span></div></div>"
                );
            }
        }

        //---------[SETUP CAROUSEL WINNERS HOME]┐
        $("#WinnersCarousel").owlCarousel({
              loop:true,
              margin:0,
              autoplay:true,
              responsiveClass:true,
              autoplayTimeout:2000,
              items:7,
              nav:false,
              navSpeed:500,
              rewind: true,
              pagination: false,
              stagePadding:0,
              smartSpeed:550,
              dots: true,
              responsive:{
                    0:{
                          items:1,
                          nav:false
                    },
                    500:{
                          items:2,
                          nav:false
                    },
                    900:{
                          items:4,
                          nav:false,
                          loop:true
                    }
              }
        });
        //---------[SETUP CAROUSEL WINNERS HOME]┘

    });*/
    //-----------------------------------------------------------------------------------------------------------------------------[LOAD JSON CAROUSEL WINNERS HOME]┘

    //--------------------------[TIMER PLAY DOTS  WINNERS HOME]┐
    /*var Loader_Dots = 1;
    var TimerDots = setInterval(TimerPlayDots, 300);
    function TimerPlayDots() {
          Loader_Dots = Loader_Dots + 1;
          if(Loader_Dots >= 4){ Loader_Dots = 1; }
          $(".BallDot").removeClass("Active");
          switch (Loader_Dots) {
                case 1: $("#DotBall_1").addClass("Active"); break;
                case 2: $("#DotBall_2").addClass("Active"); break;
                case 3: $("#DotBall_3").addClass("Active"); break;
          }
          // //logger.log("LOADER DOTS = " + Loader_Dots);
    };*/
    //--------------------------[TIMER PLAY DOTS  WINNERS HOME]┘
    //[CONTROL CAROUSEL WINNERS HOME]---------------------------------------------------[CONTROL CAROUSEL WINNERS HOME]┘



    //[CONTROL POPUPs]-------------------------------------------------------[CONTROL POPUPs]┐
      function OpenPopup(){
            TweenLite.set([".BackPopup"], {opacity:0});
            TweenMax.to(".BackPopup",0.5, {opacity:1, delay:0, ease:Quad.easeOut});
            TweenLite.set([".BtnClosePopup"], {y:-100, opacity:0});
            TweenMax.to(".BtnClosePopup",1.5, {y:0, opacity:1, delay:1, ease:Elastic.easeOut});
            TweenLite.set([".BoxContPopup"], {y:-100, opacity:0});
            TweenMax.to(".BoxContPopup",1.5, {y:0, opacity:1, delay:0.5, ease:Elastic.easeOut});
            $(".BackPopup").show();
      }
      $(".OpenPopup").click(function (event) {
          event.preventDefault();
          var PopupContent = $(this).attr("popup");
          logger.log(PopupContent);
          $(".ContInfo").hide();
          $('.ContInfo[popup="'+PopupContent+'"]').show();
          OpenPopup();
      });
      $(".BtnClosePopup").click(function () {
          $(".BackPopup").hide();
      });
      $(".BtnClosePopup").mouseover(function (event){
          TweenLite.set([ ".BtnClosePopup" ],{scale:1, rotation:0});
          TweenLite.to(this, 0.5, {scale:1.2, rotation:360, delay:"0", ease:Quad.easeOut});
      });
      $(".BtnClosePopup").mouseout(function (event){
          TweenLite.to(this, 0.5, {scale:1, delay:"0", ease:Quad.easeOut});
      });
    //[CONTROL POPUPs]-------------------------------------------------------[CONTROL POPUPs]┘



      //[INTRO TOURNAMENTS]------------------------------------------------------------------------[INTRO TOURNAMENTS]┐
      TweenLite.set(["#MainTournament"], {opacity:0, y:-100});
      TweenMax.to("#MainTournament",0.5, {opacity:1, delay:0.5, ease:Quad.easeOut});
      TweenMax.to("#MainTournament",1, { y:0, delay:0.6, ease:Back.easeOut});
      TweenLite.set(["#MainTournament .ContTableTournament .TournamentTable tr"], {y:-300});
      TweenMax.staggerTo("#MainTournament .ContTableTournament .TournamentTable tr", 0.5, {y:0, ease:Quad.easeIn}, 0.1);
      TweenLite.set(["#MainTournament .ContRowBtns"], {opacity:0, y:200});
      TweenMax.to("#MainTournament .ContRowBtns",1, {opacity:1, y:0, delay:1, ease:Back.easeOut});
      //[INTRO TOURNAMENTS]-------------------------------------------------------------------------[INTRO TOURNAMENTS]┘


      //[INTRO CRYPTOS]------------------------------------------------------------------------[INTRO CRYPTO]┐
      TweenLite.set(["#MainCryptoCon"], {opacity:0, y:-200});
      TweenMax.to("#MainCryptoCon",0.5, {opacity:1, delay:0.5, ease:Quad.easeOut});
      TweenMax.to("#MainCryptoCon",1, { y:0, delay:0.5, ease:Back.easeOut});
      //[IINTRO CRYPTO]-------------------------------------------------------------------------[INTRO CRYPTO]┘

      //[INTRO VIP LOUNGE]------------------------------------------------------------------------[INTRO VIP LOUNGE]┐
      TweenLite.set(["#HeaderVip"], {opacity:0, y:-300});
      TweenLite.set(["#MainVipLounge"], {opacity:0});
      TweenLite.set(["#BoxTitlePage"], {opacity:0, x:-500});
      TweenMax.to(["#HeaderVip"],1, {opacity:1, delay:0.5, ease:Quad.easeOut});
      TweenMax.to(["#HeaderVip"],0.5, { y:0, delay:0.5, ease:Quad.easeOut});
      TweenMax.to(["#BoxTitlePage"],1, { opacity:1, x:0, delay:0.8, ease:Back.easeOut});
      TweenMax.to("#MainVipLounge",0.5, {opacity:1, delay:1.5, ease:Quad.easeOut});
      //[IINTRO VIP LOUNGE]-------------------------------------------------------------------------[INTRO VIP LOUNGE]┘

      //[INTRO BANKING]------------------------------------------------------------------------[INTRO BANKING]┐
      var BoxCellActive = $( ".Row_N" ).toArray();
      TweenMax.set(BoxCellActive, {rotationX:0, y:"-30px", autoAlpha: 0});
      BoxCellActive.sort(function(){return 0.1-Math.random()});
      TweenMax.staggerTo(BoxCellActive,1.5, {rotationX:360, y:"0px", autoAlpha: 1, ease: Elastic.easeOut}, 0.03);
      TweenMax.set(".BoxContTable", { y:"-40px", opacity: 0});
      TweenMax.to(".BoxContTable", 0.5, { y:"0px", opacity: 1, delay:0, ease:Power2.easeOut});
      //[IINTRO BANKING]-------------------------------------------------------------------------[INTRO BANKING]┘



      //[INTRO CONTACT US]------------------------------------------------------------------------[INTROC ONTACT US]┐
      TweenLite.set(["#MainContactUs"], {opacity:0, y:-200});
      TweenMax.to("#MainContactUs",0.5, {opacity:1, delay:0.5, ease:Quad.easeOut});
      TweenMax.to("#MainContactUs",1, { y:0, delay:0.5, ease:Back.easeOut});
      //[IINTRO CONTACT US]-------------------------------------------------------------------------[INTRO CONTACT US]┘

      //[INTRO ST PAGE]------------------------------------------------------------------------[INTRO ST PAGE]┐
      TweenLite.set(["#MainStPage"], {opacity:0, y:-200});
      TweenMax.to("#MainStPage",0.5, {opacity:1, delay:0.5, ease:Quad.easeOut});
      TweenMax.to("#MainStPage",1, { y:0, delay:0.5, ease:Back.easeOut});
      //[IINTRO ST PAGE]-------------------------------------------------------------------------[INTRO ST PAGE]┘

      //[INTRO ST PAGES]------------------------------------------------------------------------[INTRO ST PAGES]┐
      TweenLite.set([".PageCont"], {opacity:0, y:-200});
      TweenMax.to(".PageCont",0.5, {opacity:1, delay:0.5, ease:Quad.easeOut});
      TweenMax.to(".PageCont",1, { y:0, delay:0.5, ease:Back.easeOut});
      //[IINTRO ST PAGES]-------------------------------------------------------------------------[INTRO ST PAGES]┘

      //[INTRO BANKING PAGES]------------------------------------------------------------------------[INTRO BANKING PAGES]┐
      TweenLite.set(["#BankingPage"], {opacity:0, y:-200});
      TweenMax.to("#BankingPage",0.5, {opacity:1, delay:0, ease:Quad.easeOut});
      TweenMax.to("#BankingPage",1, { y:0, delay:0, ease:Back.easeOut});
      //[IINTRO BANKING PAGES]-------------------------------------------------------------------------[INTRO BANKING PAGES]┘

      //[INTRO BANKING PAGES]------------------------------------------------------------------------[INTRO BANKING PAGES]┐
      TweenLite.set(["#BankinginIntPage"], {opacity:0, y:-200});
      TweenMax.to("#BankinginIntPage",0.5, {opacity:1, delay:0, ease:Quad.easeOut});
      TweenMax.to("#BankinginIntPage",1, { y:0, delay:0, ease:Back.easeOut});
      //[IINTRO BANKING PAGES]-------------------------------------------------------------------------[INTRO BANKING PAGES]┘

      //[INTRO TERMS PAGES]------------------------------------------------------------------------[INTRO TERMS PAGES]┐
      TweenLite.set(["#TermsPage"], {opacity:0, y:-200});
      TweenMax.to("#TermsPage",0.5, {opacity:1, delay:0, ease:Quad.easeOut});
      TweenMax.to("#TermsPage",1, { y:0, delay:0, ease:Back.easeOut});
      //[IINTRO TERMS PAGES]-------------------------------------------------------------------------[INTRO TERMS PAGES]┘



      // ------------------------------------- [CONTROL ACCODION TERMS]┐
        var $panel = $("div.AcordionWrapper > div.AcordionCount").hide();
        if ($(".AcordionTitle").hasClass("AcActive")) {
            logger.log("IS AcActive");
            $(".AcActive").next('.AcordionCount').slideDown();
        }else {
            logger.log("IS OFF");
        }
        $( ".AcordionTitle" ).click(function(event){
              $(this).toggleClass("AcActive");
              if ($(this).hasClass("AcActive")) {
                  logger.log("ACCODION TAB [IS ON]");
                  $(this).next('.AcordionCount').slideDown();
              }else {
                  logger.log("ACCODION TAB [IS OFF]");
                  $(this).next('.AcordionCount').slideUp();
              }
        });

        var C_Titles = 0;
        var ThisAcordion;
        $(".AcordionWrapper").each(function(C_Titles) { ThisAcordion = this; InsertNum(ThisAcordion) });

        function InsertNum(){
            $(ThisAcordion).each(function() { C_Titles = 0;
                $(ThisAcordion).find(".AcordionTitle h1").each(function() {
                    C_Titles = C_Titles + 1;
                    $(this).append('<div class="NumTitle">' +C_Titles+ '</div>');
                });
            });
        }
        // ------------------------------------- [CONTROL ACCODION TERMS]┘


        //[CONTROL TABSs]-------------------------------------------------------[CONTROL TABSs]┐
          /*$(".Tabs").click(function (event) {
              event.preventDefault();
              $(".Tabs").removeClass("ActiveGS");
              $(this).addClass("ActiveGS");
              var TabContent = $(this).attr("tabcontent");
              logger.log(TabContent);
              $(".TabsInfo").hide();
              $('.TabsInfo[tabcontent="'+TabContent+'"]').show();
               TweenLite.set(['.TabsInfo[tabcontent="'+TabContent+'"]'], {y:-100,opacity:0});
               TweenMax.to(['.TabsInfo[tabcontent="'+TabContent+'"]'],1.5, {y:0, opacity:1, delay:0.1, ease:Elastic.easeOut});
          });
          $(".TabsInfo").hide();
          $(".TabsInfo:first-child").show();*/
        //[CONTROL TABSs]-------------------------------------------------------[CONTROL TABSs]┘



        //[CONTROL QUICK DEPOSIT]-------------------------------------------------------[CONTROL QUICK DEPOSIT]┐
        // if ( $("#crytpos_slider" || $('#cryptos_dropdown')) && $.fn.owlCarousel !== undefined ) {

        //   // control quick deposit triggers
        //   const hero = $('#hero');
        //   const the_form = $('form.hero--form');
        //   const username = the_form.find('input[name="item_name"]').val();
        //   logger.log('Username: '+username);
        //   const quick_deposit_triggers = $('[data-toggle="quick_deposit"]');
        //   const quick_deposit_close = $('.quick_deposit .close');
        //   const more_cryptos_trigger = $('span[data-toggle="more-cryptos"]');
        //   const toggleCryptosDisplay = function(elems, show){
        //     show ? elems.css("display", "inline-flex") : elems.css("display", "none");
        //   }
        //   const toggleCryptosOpacity = async function(elems){
        //     if ( !elems || elems.length < 1 ) return false;
        //     elems.each(function(i) {
        //       setTimeout(() => {
        //         $(this).toggleClass('show');
        //       }, 90*i)
        //     })
        //     return false;
        //   }
        //   if ( quick_deposit_triggers ) {
        //     quick_deposit_triggers.on('click', function() {
        //       if ($('#ConMenuLeft').hasClass('Opened')) {
        //         $('#ConMenuLeft').removeClass('Opened');
        //         $('#Wrapper').removeClass('Blur');
        //         $('#BtnHamMenu').removeClass('Cross');
        //       }
        //       if ($('#hero').attr('data-show') === 'quick_deposit') { // already showing qd box
        //         $('#hero').attr('data-show', 'promos');
        //         // hide crypto selectables
        //         $('span.crypto').each(function(i) {
        //           $(this).removeClass('show');
        //         });
        //         toggleCryptosDisplay($('span.crypto:not(.top3)'), 0);
        //       } else { // show qd box
        //         $('#hero').attr('data-show', 'quick_deposit');
        //         more_cryptos_trigger.removeClass('open');
        //         // show crypto selectables
        //         toggleCryptosOpacity($('span.crypto.top3'));
        //       }
        //     })
        //   }
        //   if ( more_cryptos_trigger ) {
        //     more_cryptos_trigger.on('click', function() {
        //       more_cryptos_trigger.toggleClass('open');
        //       // show more crypto selectables
        //       toggleCryptosOpacity($('span.crypto:not(.top3)'))
        //       .then(function(){
        //         toggleCryptosDisplay($('span.crypto:not(.top3)'), more_cryptos_trigger.hasClass('open'));
        //       })
        //     })
        //   }
        //   if ( quick_deposit_close ) {
        //     quick_deposit_close.on('click', () => {
        //       $('#hero').attr('data-show', 'promos');
        //       // hide crypto selectables
        //       $('span.crypto').each(function(i) {
        //         $(this).removeClass('show');
        //       });
        //       toggleCryptosDisplay($('span.crypto:not(.top3)'), 0);
        //     })
        //   }

        //   // control crypto select tabs
        //   const quick_deposit_btn = $('#quick_deposit_btn');
        //   const crypto_tabs = $('input[name="currency"][type="radio"]');
        //   // check if crypto selected and show an error message if not
        //   if ( quick_deposit_btn ) {
        //     quick_deposit_btn.on('click', function(e){
        //       let msgs = $('form.hero--form .msg');
        //       if (msgs) msgs.each(function(){ $(this).remove() });
        //       if ( !$('input[name="currency"][type="radio"]').is(':checked') ){
        //         $('<p class="msg bad mt-15">Please select your preferred crypto currency.</p>').insertAfter(quick_deposit_btn);
        //       }
        //     })
        //   }
        //   // remove messages if any once the crypto is selected
        //   if ( crypto_tabs ) {
        //     crypto_tabs.on('click', function(e) {
        //       $('span.crypto[data-item="crypto_tab"]').removeClass('selected');
        //       const selected_crypto_tab = e.target.closest('span.crypto');
        //       selected_crypto_tab.classList.add('selected');
        //       let msgs = $('form.hero--form .msg');
        //       if (msgs) msgs.each(function(){ $(this).remove() });
        //       // check if Credit Card option
        //       if (selected_crypto_tab.id === 'CCC') {
        //         $('form.hero--form').get(0).setAttribute('action', "/cashier?deposit");
        //       } else {
        //         $('form.hero--form').get(0).setAttribute('action', "https://aonsiri.com/alt/process-test-new.php");
        //       }
        //       quick_deposit_btn.removeClass('disabled');
        //     })
        //   }
        // }
        //[CONTROL QUICK DEPOSIT]-------------------------------------------------------[CONTROL QUICK DEPOSIT]┐
        const QD = new QuickDeposit;
        QD.init();
        //[CONTROL QUICK DEPOSIT]-------------------------------------------------------[CONTROL QUICK DEPOSIT]┘


    }

    return {
      init
    }

})();
